function slideList(els) {
  els.forEach((el) => {
    const swiperEl = el.querySelector(".js-list-swiper");
    const prevEl = el.querySelector(".js-list-swiper__prev");
    const nextEl = el.querySelector(".js-list-swiper__next");
    const buttonWrapperEl = el.querySelector(".c-slide-list__button-wrapper");

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      on: {
        resize(swiperInstance) {
          if (!buttonWrapperEl) return;
          buttonWrapperEl.classList.toggle("is-hidden", swiperInstance.isLocked);
        },
      },
      breakpoints: {
        768: {
          slidesPerGroup: 2,
        },
      },
    });

    if (buttonWrapperEl) {
      buttonWrapperEl.classList.toggle("is-hidden", swiper.isLocked);
    }
  });
}
